document.addEventListener("DOMContentLoaded", () => {
  const timeElements = document.querySelectorAll(".article-card__header time");

  timeElements.forEach((timeElement) => {
    const datetime = timeElement.getAttribute("datetime");
    if (datetime) {
      const date = new Date(datetime);
      const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase(); // "DEC"
      const day = date.toLocaleString("en-US", { day: "2-digit" }); // "02"
      
      // Create the spans and set their content
      const monthSpan = document.createElement("span");
      monthSpan.classList.add("month");
      monthSpan.textContent = month;

      const daySpan = document.createElement("span");
      daySpan.classList.add("date");
      daySpan.textContent = day;

      // Clear any existing content and append the formatted spans
      timeElement.innerHTML = ""; // Clear the existing content
      timeElement.appendChild(monthSpan);
      timeElement.appendChild(daySpan);
    }
  });
});



jQuery(document).ready(function($){

  

$('.template-index .seona-mood ul.collection-list').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: true,
  centerMode: false,
  focusOnSelect: false,
  responsive: [
    {
      breakpoint: 980, // At screen widths <= 980px
      settings: {
        slidesToShow: 2, // Show 2 slides
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600, // At screen widths <= 600px
      settings: {
        slidesToShow: 1, // Show 1 slide
        slidesToScroll: 1
      }
    }
  ]
});






$('.template-article .blog__posts.articles-wrapper').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  centerMode: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 980, // At screen widths <= 980px
      settings: {
        slidesToShow: 2, // Show 2 slides
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600, // At screen widths <= 600px
      settings: {
        slidesToShow: 1, // Show 1 slide
        slidesToScroll: 1
      }
    }
  ]
});


// $('.seona-bestsellers ul.slider').slick({
//   responsive: [
//     {
//       breakpoint: 980, // At screen widths <= 980px
//       settings: {
//         slidesToShow: 2, // Show 2 slides
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 767, // At screen widths <= 600px
//       settings: {
//         slidesToShow: 1, // Show 1 slide
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     }
//   ]
// });  

  
});



$(document).ready(function() {
    $('.blog__post').each(function() {
        var tags = $(this).find('.article-tags'); // Select the article-tags div
        var header = $(this).find('.article-card__header'); // Select the header
        
        // Append the article-tags to the header
        tags.appendTo(header);
    });
});





document.addEventListener("DOMContentLoaded", function () {
  const tocContainer = document.querySelector("#article-toc ul");
  const headings = document.querySelectorAll(".article-template__content .my-content h2, .article-template__content .my-content h3, .article-template__content .my-content h4, .article-template__content .my-content h5");

  headings.forEach((heading) => {
    const listItem = document.createElement("li");
    const link = document.createElement("a");

    // Set the ID if it doesn't exist
    if (!heading.id) {
      heading.id = heading.textContent.toLowerCase().replace(/ /g, "-");
    }

    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;

    // Add a class based on the heading level
    listItem.classList.add(`toc-${heading.tagName.toLowerCase()}`);
    listItem.style.marginLeft = `${(parseInt(heading.tagName[1]) - 2) * 1.5}rem`;
    listItem.appendChild(link);
    tocContainer.appendChild(listItem);
  });

// Adjust scroll position with offset and highlight target
  const links = document.querySelectorAll("#article-toc a");
  links.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);
      const offset = 64; // Offset in pixels

      if (targetElement) {
        // Remove highlight from all headings
        headings.forEach((heading) => heading.classList.remove("highlight"));

        // Scroll to the target with offset
        const targetPosition = targetElement.offsetTop;
        const offsetPosition = targetPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });

        // Add highlight class to the target element
        targetElement.classList.add("highlight");
      }
    });

});
  
});




// // Product listing slider
// (function($) {
//   $(document).ready(function() {

//      $(window).on('load', function() {
//       setTimeout(function() {
    
//         $('.card__colors').slick({
//           infinite: false,
//           slidesToShow: 4,
//           slidesToScroll: 1,
//           dots: false,
//           variableWidth: true,
//         });



//       }, 1000); 
//     });



//   });
// })(jQuery);



// document.addEventListener('DOMContentLoaded', function() {
//   const productsGrid = document.querySelector('#ProductGridContainer'); // Replace with the actual selector for your product grid container
  
//   if (productsGrid) {
//     // We'll use a MutationObserver to watch for changes to the product grid's DOM
//     const observer = new MutationObserver(function(mutationsList) {
//       for (const mutation of mutationsList) {
//         if (mutation.type === 'childList') {
//           // A change was detected, so re-initialize the Slick slider.
//           // First, check if the slider is already initialized and destroy it to prevent duplication.
//           const slider = $('.card__colors');
//           if (slider.hasClass('slick-initialized')) {
//             slider.slick('unslick');
//           }
          
//           if (slider.length) {
//             slider.slick({
//               infinite: false,
//               slidesToShow: 4,
//               slidesToScroll: 1,
//               dots: false,
//               variableWidth: true,
//             });
//           }
//         }
//       }
//     });

//     // Start observing the target element for configured mutations
//     observer.observe(productsGrid, { childList: true });
//   }

//   // Initial initialization when the page first loads
//   const initialSlider = $('.card__colors');
//   if (initialSlider.length) {
//     initialSlider.slick({
//       infinite: false,
//       slidesToShow: 4,
//       slidesToScroll: 1,
//       dots: false,
//       variableWidth: true,
//     });
//   }
// });


document.addEventListener('DOMContentLoaded', function() {

  function initCardScripts() {
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      const addToCartBtn = card.querySelector('add-to-cart');
      const colorSwatches = card.querySelectorAll('.color-swatch');
      const productTitle = card.querySelector('.card-information__text.h4');
      const mainImage = card.querySelector('.card--image-animate picture');
      const cardLinks = card.querySelectorAll('a[href*="products"]');
      const priceContainer = card.querySelector('.price');
      const variantColorElements = card.querySelectorAll('.variant-color');

      if (!addToCartBtn || !colorSwatches.length) return;

      if (card.getAttribute('data-card-initialized')) return;
      card.setAttribute('data-card-initialized', 'true');

      const productType = card.getAttribute('data-product-type') || 'Product';
      let baseProductName = card.getAttribute('data-product-title');
      if (!baseProductName && productTitle) baseProductName = productTitle.textContent.trim();
      if (!baseProductName) baseProductName = 'Product';

      // Set active swatch based on initial variant
      const initialVariantId = card.getAttribute('data-initial-variant-id');
      colorSwatches.forEach(s => {
        if (s.getAttribute('data-variant-id') === initialVariantId) {
          s.classList.add('is-active');
        } else {
          s.classList.remove('is-active');
        }
      });

      const activeSwatch = Array.from(colorSwatches).find(s => s.classList.contains('is-active'));
      if (activeSwatch) {
        const initPrice = activeSwatch.getAttribute('data-variant-price');
        const initComparePrice = activeSwatch.getAttribute('data-variant-compare-price');
        if (initPrice) updatePriceDisplay(initPrice, initComparePrice);
      }

      // Set initial variant color label
      if (variantColorElements.length) {
        const activeVariant = Array.from(colorSwatches).find(s => s.classList.contains('is-active'))?.getAttribute('data-variant-title') || 'Product';
        variantColorElements.forEach(el => {
          el.textContent = activeVariant;
        });
      }

      function formatPrice(priceInCents) {
        const dollars = Math.floor(priceInCents / 100);
        const cents = (priceInCents % 100).toString().padStart(2, '0');
        return `$${dollars}.${cents}`;
      }

      function updatePriceDisplay(variantPrice, variantComparePrice) {
        if (!priceContainer) return;
        const price = parseInt(variantPrice);
        const comparePrice = variantComparePrice ? parseInt(variantComparePrice) : 0;
        const regularDiv = priceContainer.querySelector('.price__regular');
        const saleDiv = priceContainer.querySelector('.price__sale');
        if (!regularDiv || !saleDiv) return;
        const isOnSale = comparePrice > price;
        if (isOnSale) {
          const compareSpan = saleDiv.querySelector('.price-item--regular');
          if (compareSpan) compareSpan.innerHTML = `<price-money><bdi>${formatPrice(comparePrice)}</bdi></price-money>`;
          const saleSpan = saleDiv.querySelector('.price-item--sale');
          if (saleSpan) saleSpan.innerHTML = `<price-money><bdi>${formatPrice(price)}</bdi></price-money>`;
        } else {
          const regularSpan = regularDiv.querySelector('.price-item--regular');
          if (regularSpan) regularSpan.innerHTML = `<price-money><bdi>${formatPrice(price)}</bdi></price-money>`;
        }
      }

      function updateMainImage(variantImageSrc, variantImageSrcset) {
        if (!variantImageSrc) return;
        if (mainImage) {
          mainImage.querySelectorAll('img').forEach(img => {
            img.src = variantImageSrc;
            if (variantImageSrcset) img.srcset = variantImageSrcset;
          });
          const source = mainImage.querySelector('source');
          if (source && variantImageSrcset) source.srcset = variantImageSrcset;
        }
        card.querySelectorAll('picture[is="prog-picture"]').forEach(picture => {
          picture.querySelectorAll('img').forEach(img => {
            img.src = variantImageSrc;
            if (variantImageSrcset) img.srcset = variantImageSrcset;
          });
          const source = picture.querySelector('source');
          if (source && variantImageSrcset) source.srcset = variantImageSrcset;
        });
      }

      function showAddToCartConfirmation(variantTitle, baseProductName, productType) {
        const existingToast = document.querySelector('.add-to-cart-toast');
        if (existingToast) existingToast.remove();
        const message = `${baseProductName} - ${variantTitle} - ${productType} added to cart`;
        const toast = document.createElement('div');
        toast.className = 'add-to-cart-toast';
        toast.textContent = message;
        document.body.appendChild(toast);
        setTimeout(() => {
          toast.classList.add('fade-out');
          setTimeout(() => toast.remove(), 300);
        }, 3000);
      }

      addToCartBtn.addEventListener('click', function() {
        const activeVariantTitle = Array.from(colorSwatches).find(s => s.classList.contains('is-active'))?.getAttribute('data-variant-title') || 'Product';
        showAddToCartConfirmation(activeVariantTitle, baseProductName, productType);
      });

      colorSwatches.forEach((swatch) => {
        swatch.style.cursor = 'pointer';
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const variantId = this.getAttribute('data-variant-id');
          const variantTitle = this.getAttribute('data-variant-title');
          const variantPrice = this.getAttribute('data-variant-price');
          const variantComparePrice = this.getAttribute('data-variant-compare-price');
          const variantImageSrc = this.getAttribute('data-src');
          const variantImageSrcset = this.getAttribute('data-srcset');
          const variantUrl = this.querySelector('a')?.href;

          if (variantId) {
            addToCartBtn.setAttribute('data-variant-id', variantId);
            colorSwatches.forEach(s => s.classList.remove('is-active'));
            this.classList.add('is-active');
            updateMainImage(variantImageSrc, variantImageSrcset);
            if (variantUrl) cardLinks.forEach(link => link.href = variantUrl);
            updatePriceDisplay(variantPrice, variantComparePrice);

            // Update variant color label on swatch click
            if (variantTitle && variantColorElements.length) {
              variantColorElements.forEach(el => {
                el.textContent = variantTitle;
              });
            }

            if (variantTitle && productTitle) {
              const baseTitle = productTitle.textContent;
              if (!baseTitle.includes(variantTitle)) {
                productTitle.textContent = baseTitle.split(' - ')[0] + ' - ' + variantTitle;
              }
            }
          }
          return false;
        });
      });
    });
  }

  function reorderSwatches() {
    document.querySelectorAll('.card__colors').forEach(function(container) {
      const swatches = Array.from(container.querySelectorAll('[data-variant-id]'));
      if (!swatches.length) return;

      const active = swatches.find(s => s.classList.contains('is-active'));
      if (!active) return;

      container.prepend(active);

      const others = Array.from(container.querySelectorAll('[data-variant-id]'))
        .filter(s => s !== active);

      for (let i = others.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [others[i], others[j]] = [others[j], others[i]];
      }

      others.forEach(s => container.appendChild(s));
    });
  }

  function destroySlider() {
    const slider = $('.card__colors');
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  }

  function initSlider() {
    const slider = $('.card__colors');
    if (slider.length) {
      slider.slick({
        infinite: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        variableWidth: true,
        responsive: [{
          breakpoint: 650,
          settings: {
             slidesToShow: 4,
          }
        }]
      });
    }
  }

  function swatchesResize() {
    /**
 * Adjusts swatch dimensions based on container width and screen size
 */
const resizeSwatches = () => {
        // Target the container
        const containers = document.querySelectorAll('.product-grid .card__colors--large');
        
        // Check if the screen is mobile size (650px and below)
        const isMobile = window.innerWidth <= 650;
        
        // Set percentage: 18.66% for mobile, 16.66% for desktop
        const percentage = isMobile ? 0.1766667 : 0.12666667;

        containers.forEach(container => {
            // Get the actual pixel width of the container
            const containerWidth = container.offsetWidth;
            
            // Calculate the target size based on our percentage
            const targetSize = containerWidth * percentage;

            // Find all swatches inside this specific container
            const swatches = container.querySelectorAll('.color-swatch');

            swatches.forEach(swatch => {
                // Apply the calculated size to both width and height
                swatch.style.width = `${targetSize - 10}px`;
                swatch.style.height = `${targetSize - 10}px`;
                
                // Override Slick's flex-basis to ensure perfect alignment
                swatch.style.flex = `0 0 ${targetSize  - 10}px`; 
                
                // Optional: Ensure max-width doesn't block the increase
                swatch.style.maxWidth = `${targetSize  - 10}px`;
            });
        });
    };

    // 1. Run on initial load
    window.addEventListener('load', resizeSwatches);

    // 2. Run whenever the window is resized
    window.addEventListener('resize', resizeSwatches);

    // 3. Keep the Slick Slider hook to ensure it recalculates after sliding
    $('.product-grid .card__colors--large').on('setPosition', function() {
        resizeSwatches();
    });
  }

  // Run on initial page load
 
  initCardScripts();   // 2. Bind events, set .is-active, set variant color label
  reorderSwatches();   // 3. Reorder swatches based on .is-active
  initSlider();        // 4. Init slider on reordered swatches
  swatchesResize();

  // Run after every filter/sort AJAX reload
  document.addEventListener('grid:updated', function() {
    destroySlider();

    initCardScripts();   // 2. Bind events, set .is-active, set variant color label
    reorderSwatches();   // 3. Reorder swatches based on .is-active
    initSlider();        // 4. Init slider on reordered swatches
    swatchesResize();
  });

});










// (function() {
//   const applyCustomSwatches = (root = document) => {
//     // Find all swatches that haven't been processed yet
//     const swatches = root.querySelectorAll('.color-swatch[title]:not([data-custom-ready])');
    
//     swatches.forEach(swatch => {
//       const title = swatch.getAttribute('title');
//       if (!title) return;

//       // Convert "Red Magma" to "Red_Magma"
//       const fileName = title.replace(/\s+/g, '_');
      
//       // We set a CSS variable on the element itself
//       // Try png first as per your requirement
//       const imageUrl = `//xyd8z8-6h.myshopify.com/cdn/shop/files/${fileName}.png`;
      
//       swatch.style.setProperty('--custom-swatch-image', `url(${imageUrl})`);
//       swatch.setAttribute('data-custom-ready', 'true');
//     });
//   };

//   // Watch for AJAX grid changes
//   const targetNode = document.getElementById('ProductGridContainer');
//   if (targetNode) {
//     const observer = new MutationObserver((mutations) => {
//       const added = mutations.some(m => m.addedNodes.length > 0);
//       if (added) {
//         // Small delay to ensure HTML is fully settled
//         setTimeout(() => applyCustomSwatches(targetNode), 50);
//       }
//     });
//     observer.observe(targetNode, { childList: true, subtree: true });
//   }

//   // Initial Run
//   applyCustomSwatches();
// })();



